// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RK7n","left":"styles_left__1z0bO"};